
const digest = 'dad3fd97f6da413794151a3736fbf35fded50351c1c424714186f407b154dcb3';
const classes = {"buttonContainer":"_buttonContainer_17sqt_1"};
const css = `._buttonContainer_17sqt_1 {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 8px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  